import React from 'react';
import UserSelect from '../Shared/UserSelect';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import classNames from 'classnames';
import { Link } from 'react-router';

class MultiUserSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedId : -1,
      selectedUser : null
    }
  }

  handleUserSelect(user){
    if(user){
      this.setState({
        selectedId : user.Id,
        selectedUser : user
      });
    }
    else{
      this.setState({
        selectedId : -1,
        selectedUser : user
      });
    }
  }

  handleRemoveUser(user){
    const {onRemove} = this.props;
    if(onRemove){
      onRemove(user);
    }
  }

  handleAdd(){
    if(this.state.selectedId >= 0){
        this.setState({
          selectedId : -1,
          selectedUser : null
        });
        const {onAdd} = this.props;
        if(onAdd){
          onAdd(this.state.selectedUser);
        }
    }
  }


  render() {
    const includeManager = this.props.includeManager || false;
    const className = this.props.className || '';
    const style = this.props.style || {};
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    const { value } = this.props;
    
    return (
      <div className={className} style={style}>
        <div className="row">
            <div className="col-md-9">
              <UserSelect  includeManager={includeManager} userId={this.state.selectedId} onSelectUser={this.handleUserSelect.bind(this)}/>
            </div>
            <div className="col-md-3" style={{paddingLeft:'0px'}}>
              <button type="button" onClick={this.handleAdd.bind(this)} className="btn btn-default btn-brand pull-left">{t('Add')}</button>
            </div>
        </div>
        <table className="table table-condensed table-bordered " style={{marginTop:'5px'}}>
                <thead>
                  <tr>
                      <th>#</th>
                      <th>{t('Display Name')}</th>
                      {includeManager && 
                        (<th>{t('Manager')}</th>)
                      }
                      <th>{t('Remove')}</th>
                  </tr> 
                </thead>
                <tbody>
                  {
                        (value && value.length <= 0) && (<tr >
                              <td colSpan={includeManager ? 6 : 5} >
                                {
                                  !this.props.children && 
                                  <div className="alert alert-danger" style={{marginBottom : '0px'}}>
                                    <strong>{t('No name selected')}! </strong>{t('Please select a name and click')} <strong>{t('Add')}</strong>.
                                  </div>
                                }
                                {
                                  this.props.children
                                }
                              </td>
                        </tr>)
                  }

                  {
                    (value).map((m, idx) => 
                      (<tr key={m.Id}>
                          <td><Link to={"/user/" + m.Id}>{m.Id}</Link></td>
                          <td>{m.DisplayName}</td>
                           {includeManager && 
                           (<td>
                            {m.Manager ? m.Manager.DisplayName : ''} 
                           </td>)
                           }
                          <td><button className="btn btn-default btn-danger btn-xs" onClick={this.handleRemoveUser.bind(this, m)}><i className="glyphicon glyphicon-remove"/></button></td>
                      </tr>)
                    )
                  }
                </tbody>
          </table>
    </div>
    );
  }
}

MultiUserSelect.displayName = 'MultiUserSelect';
MultiUserSelect.propTypes = { includeManager : React.PropTypes.bool, onChange : React.PropTypes.func};
MultiUserSelect.defaultProps = {};

export default injectIntl(MultiUserSelect);


// WEBPACK FOOTER //
// ./components/Shared/MultiUserSelect.js